
import Vue, { PropType } from "vue";
import KFieldGroup from "@/components/crud/fields/KFieldGroup.vue";
import KTextField from "@/components/crud/fields/KTextField.vue";
import KEnumSelect from "@/components/crud/fields/KEnumSelect.vue";
import { OrderStatus } from "@/modules/salesOrder/enum/OrderStatus";
import { UnitLoad } from "@/modules/delivery/enums";

type ComponentData = {
  internalFilters: Record<string, any>;
  OrderStatus: Record<string, string>;
  UnitLoad: Record<string, string>;
};

export default Vue.extend({
  name: "ProductFilter",
  components: { KTextField, KFieldGroup, KEnumSelect },
  props: {
    filters: {
      type: Object as PropType<Record<string, any>>,
      required: true,
    },
  },
  data: (): ComponentData => ({
    OrderStatus: OrderStatus,
    UnitLoad: UnitLoad,
    internalFilters: {
      dateFrom: undefined,
      dateTo: undefined,
      statusId: undefined,
      unitLoad: undefined,
    },
  }),
  watch: {
    filters: {
      handler(newFilters) {
        this.internalFilters = newFilters;
      },
      immediate: true,
      deep: true,
    },
    internalFilters: {
      handler(newFilters) {
        this.$emit("update:filters", newFilters);
      },
    },
  },
});
